// extracted by mini-css-extract-plugin
export default {"boxdraw":"boxSelection-module__boxdraw__BlcAA"};